import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import GuestRoute from '../components/GuestRoute';
import Login from '../pages/auth/Login';
import AuthForgot from '../sections/auth/AuthForgot';
import AuthReset from '../sections/auth/AuthResetPassord';
import LandingPage from '../pages/LandingPage';
// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));
// const AuthForgot = Loadable(lazy(() => import('pages/auth/AuthForgot')));

// ==============================|| AUTH ROUTING ||============================== //
const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '',
      element: (
        <GuestRoute>
           <Login />
          {/* <LandingPage /> */}
        </GuestRoute>
      )
    },
    {
      path: 'login',
      element: (
        <GuestRoute>
          <Login />
        </GuestRoute>
      )
    },
    {
      path: 'register',
      element: (
        <GuestRoute>
          <RegisterPage />
        </GuestRoute>
      )
    },
     {
      path: 'forgot-password',
      element: (
        <GuestRoute>
          <AuthForgot />
        </GuestRoute>
      )
    },
     {
      path: 'reset-password',
      element: (
        <GuestRoute>
          <AuthReset />
        </GuestRoute>
      )
    }
  ]
};

export default LoginRoutes;
